exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.upload-demo[data-v-fdef3a92] .el-upload--picture-card {\n\twidth: auto;\n\theight: 0px;\n\tline-height: 12px;\n\tborder: 0px dashed #c0ccda;\n}\n", ""]);

// exports
